import { QuestionType } from 'types/genericQuestion';

export const CROSS_QUESTION_TYPES = [
  QuestionType.CHOICES,
  QuestionType.SCALE,
  QuestionType.YES_NO,
  QuestionType.DROPDOWN,
];
